import { render, staticRenderFns } from "./DocumentsAddEditModal.vue?vue&type=template&id=74a3aa5f&scoped=true&"
import script from "./DocumentsAddEditModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsAddEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsAddEditModal.vue?vue&type=style&index=0&id=74a3aa5f&prod&scoped=true&lang=css&"
import style1 from "./DocumentsAddEditModal.vue?vue&type=style&index=1&id=74a3aa5f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a3aa5f",
  null
  
)

export default component.exports